import { InputNumber, Switch } from 'antd';
import { formatarMoeda } from '../utils';
import * as styles from '../styles';
import { ReviewFieldWrapper } from '../../../../ReviewFieldWrapper';

interface AreaNaoAverbadaSectionProps {
  especificarAreaNaoAverbada: boolean;
  areaNaoAverbada: number;
  fatorAjusteNaoAverbada: number;
  valorUnitarioNaoAverbada: number;
  valorParcialNaoAverbada: number;
  onUpdateAreaNaoAverbada?: (
    campo: 'especificarAreaNaoAverbada' | 'areaNaoAverbada' | 'fatorAjusteNaoAverbada',
    valor: boolean | number
  ) => void;
  disabled?: boolean;
}

export function AreaNaoAverbadaSection({
  especificarAreaNaoAverbada,
  areaNaoAverbada,
  fatorAjusteNaoAverbada,
  valorUnitarioNaoAverbada,
  valorParcialNaoAverbada,
  onUpdateAreaNaoAverbada,
  disabled,
}: AreaNaoAverbadaSectionProps) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ ...styles.areaAverbadaSwitchStyle, alignItems: 'center' }}>
        <ReviewFieldWrapper
          fieldPath="amostras.especificarAreaNaoAverbada"
          fieldLabel="Área construída não averbada (switch)"
          stepName="Metodologia"
          linkInline={true}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Switch
              checked={especificarAreaNaoAverbada}
              onChange={(checked: boolean) => {
                onUpdateAreaNaoAverbada?.('especificarAreaNaoAverbada', checked);
                // Quando ativar, inicializa a área com 1.00 e fator com 1.00 se estiverem 0
                if (checked) {
                  if (!areaNaoAverbada) {
                    onUpdateAreaNaoAverbada?.('areaNaoAverbada', 1);
                  }
                  if (!fatorAjusteNaoAverbada) {
                    onUpdateAreaNaoAverbada?.('fatorAjusteNaoAverbada', 1);
                  }
                }
              }}
              disabled={disabled ?? false}
            />
            <h4 style={{ ...styles.areaTitleStyle, margin: 0 }}>Área construída não averbada</h4>
          </div>
        </ReviewFieldWrapper>
      </div>

      {especificarAreaNaoAverbada && (
        <div style={styles.tableBorderStyle}>
          <div style={styles.tableRowWithBorderStyle}>
            <div style={styles.tableCellLabelStyle}>Área (m²)</div>
            <div style={styles.tableCellInputStyle}>
              <ReviewFieldWrapper
                fieldPath="amostras.areaNaoAverbada"
                fieldLabel="Área Não Averbada (m²)"
                stepName="Metodologia"
              >
                <InputNumber
                  value={areaNaoAverbada ?? 1}
                  // Preserva o 0 digitado e ignora o campo vazio (null) para o
                  // usuário poder apagar tudo e redigitar sem voltar para 1.
                  onChange={(value) => {
                    if (value === null) return;
                    onUpdateAreaNaoAverbada?.('areaNaoAverbada', value);
                  }}
                  style={{ width: '100%' }}
                  step={0.01}
                  precision={2}
                  decimalSeparator=","
                  placeholder="1,00"
                  disabled={disabled ?? false}
                />
              </ReviewFieldWrapper>
            </div>
          </div>

          <div style={styles.tableRowWithBorderStyle}>
            <div style={styles.tableCellLabelStyle}>F. Ajuste</div>
            <div style={styles.tableCellInputStyle}>
              <ReviewFieldWrapper
                fieldPath="amostras.fatorAjusteNaoAverbada"
                fieldLabel="Fator de Ajuste Área Não Averbada"
                stepName="Metodologia"
              >
                <InputNumber
                  value={fatorAjusteNaoAverbada ?? 1}
                  onChange={(value) => {
                    if (value === null) return;
                    onUpdateAreaNaoAverbada?.('fatorAjusteNaoAverbada', value);
                  }}
                  style={{ width: '100%' }}
                  step={0.01}
                  precision={2}
                  decimalSeparator=","
                  placeholder="1,00"
                  disabled={disabled ?? false}
                />
              </ReviewFieldWrapper>
            </div>
          </div>

          <div style={styles.tableRowWithBorderStyle}>
            <div style={styles.tableCellLabelStyle}>Valor unitário (R$/m²)</div>
            <div style={styles.tableCellValueStyle}>{formatarMoeda(valorUnitarioNaoAverbada)}</div>
          </div>

          <div style={styles.tableRowStyle}>
            <div style={styles.tableCellLabelStyle}>Valor parcial (R$)</div>
            <div style={styles.tableCellHighlightStyle}>
              {formatarMoeda(valorParcialNaoAverbada)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
